import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export interface Alarm {
    bl_no: string;
    o_kind: string;
    o_kind_text: string;
    o_date: string;
}

interface AlarmResponse {
    statusCode: number;
    message: string;
    data: Alarm[];
}

export const useGetAlarm = (): UseQueryResult<Alarm[], Error> => {
    return useQuery({
        queryKey: ["useGetAlarm"],
        queryFn: async () => {
            const response = await axiosInstance.get<AlarmResponse>(enum_api_uri.get_alarm);
            return response.data.data;
        },
    });
};
